import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M6.5443 8.211v12.9036H2.2474V8.2109h4.2969zm.2734-3.9844c.0087.6336-.2105 1.1632-.6575 1.5885-.447.4254-1.0352.638-1.7644.638h-.026c-.7118 0-1.2847-.2126-1.7188-.638C2.217 5.3898 2 4.8602 2 4.2266c0-.6424.2235-1.174.6706-1.595C3.1176 2.2104 3.7014 2 4.4219 2c.7205 0 1.2977.2105 1.7317.6315.434.421.6554.9527.6641 1.595zM22 13.7187v7.3959h-4.2839v-6.901c0-.9115-.1757-1.6255-.5273-2.142s-.9006-.7747-1.6471-.7747c-.547 0-1.0048.1497-1.3737.4492-.369.2995-.6446.6706-.8269 1.1133-.0954.2604-.1432.612-.1432 1.0547v7.2005H8.9141c.0173-3.4636.026-6.2717.026-8.4245s-.0043-3.4375-.013-3.8542l-.013-.625h4.2838v1.875h-.026c.1736-.2777.3515-.5208.5338-.7291.1823-.2084.4275-.434.7357-.6771.3082-.243.6858-.4319 1.1328-.5664.447-.1346.944-.2018 1.4909-.2018 1.4844 0 2.678.4926 3.5807 1.4778.9028.9853 1.3542 2.4284 1.3542 4.3294z",
    fillRule: "evenodd"
  }],
  circles: []
};
var LinkedinIcon = function LinkedinIcon(props) {
  return renderIcon(props, iconType);
};
export { LinkedinIcon };